import React from 'react';
import { Link } from 'react-router-dom';

import {
  AppBreadcrumbs,
  ButtonApp,
  LayoutApartmentItem,
} from 'src/components';
import { useTranslations } from 'src/hooks/translataions';
import { locals } from 'src/constants/locals';
import { useComparePageLink } from 'src/hooks/useComparePageLink';
import { useAppMediaQuery } from 'src/hooks/app/useAppMediaQuery';
import { useStyles } from './styles';
import { useFavoriteList } from './hooks';

export const FavoritesList: React.FC = () => {
  const styles = useStyles({});
  const {
    idsDisplayed,
    displayedFavoritePlacement,
  } = useFavoriteList();
  const { getTranslations } = useTranslations();
  const { comparePageRouteLink } = useComparePageLink();
  const { isMdUp } = useAppMediaQuery();

  return (
    <div className={styles.wrapperContainer}>
      <div className={styles.headerBlock}>
        <div className={styles.headerBlockFavCrumbs}>
          { isMdUp && (
            <AppBreadcrumbs />
          )}
          <h2 className={styles.titleBlock}>{getTranslations(locals.appTranslations.appFavorites)}</h2>
        </div>
        {idsDisplayed.length >= 2 && (
          <Link to={comparePageRouteLink}>
            <ButtonApp
              isCapitalize
              className={styles.compareButton}
              text={getTranslations(locals.appTranslations.appCompareApartments)}
              variant="contained"
            />
          </Link>
        )}
      </div>
      {idsDisplayed.length === 0 && (
        <p className={styles.emptyFavorites}>{getTranslations(locals.appTranslations.appEmptyFavorites)}</p>
      )}
      <div className={styles.wrapperFavoriteList}>
        {displayedFavoritePlacement.map((favItem) => {
          return (
            <LayoutApartmentItem
              key={favItem.id}
              withSizeLimits
              wrapperStyle={styles.favoritePlacement}
              wrapperImageStyle={styles.imageApartmentStyleXl}
              property={favItem}
            />
          );
        })}
      </div>
    </div>
  );
};
